module.exports = __webpack_public_path__ + "static/agribio-55721eace2b1f950a54ef7e0614b9dfc.jpg";